const regionMapping = {
  region1: "Western Outskirts",
  region2: "Borderline South",
  region3: "Coastal South",
  region4: "South Central",
  region5: "Far East",
  region6: "Arid Central North",
  region7: "West Basin",
  region8: "Coastal North",
}

export const regions = Object.values(regionMapping)

export const regionIdMapping = {
  "Coastal North": 1,
  "Far East": 2,
  "Coastal South": 3,
  "South Central": 4,
  "Arid Central North": 5,
  "West Basin": 6,
  "Borderline South": 7,
  "Western Outskirts": 8,
}

const {
  region1,
  region2,
  region3,
  region4,
  region5,
  region6,
  region7,
  region8,
} = regionMapping

export const regionCenter = [
  [250, 410],
  [555, 690],
  [760, 710],
  [700, 570],
  [810, 540],
  [580, 390],
  [530, 560],
  [880, 250],
]

export const dishTooltipPositionMapping = {
  [region1]: [
    { top: "5%", left: "5%", transform: "translate(-55%, -50%)" },
    { top: "5%", left: "95%", transform: "translate(-70%, -50%)" },
    { top: "95%", left: "5%" },
    { top: "95%", left: "95%", transform: "translate(-50%, -50%)" },
  ],
  [region2]: [
    { top: "50%", left: "0%" },
    { top: "50%", left: "100%" },
  ],
  [region3]: [
    { top: "5%", left: "0%", transform: "translate(-75%, -50%)" },
    { top: "100%", left: "0%", transform: "translate(-70%, -40%)" },
    { top: "100%", left: "50%", transform: "translate(-50%,-25%)" },
    { top: "0%", left: "50%", transform: "translate(-50%,-75%)" },
    { top: "5%", left: "100%", transform: "translate(-25%,-50%)" },
    { top: "100%", left: "100%", transform: "translate(-30%, -40%)" },
  ],
  [region4]: [
    { top: "0%", left: "50%", transform: "translate(-50%,-65%)" },
    { top: "100%", left: "50%", transform: "translate(-50%,-35%)" },
  ],
  [region5]: [
    { top: "40%", left: "100%", transform: "translate(-5%,-50%)" },
    { top: "80%", left: "15%", transform: "translate(-25%,-10%)" },
    { top: "100%", left: "100%", transform: "translate(-10%,-5%)" },
    { top: "0%", left: "0%", transform: "translate(-110%,-50%)", zIndex: 2 },
    { top: "0%", left: "40%", transform: "translate(-50%, -75%)" },
    { top: "0%", left: "100%", transform: "translate(-10%, -110%)" },
  ],
  [region6]: [
    { top: "0%", left: "50%", transform: "translate(-50%, -55%)" },
    { top: "60%", left: "100%" },
    { top: "80%", left: "3%" },
  ],
  [region7]: [
    { top: "25%", left: "0%", transform: "translate(-100%,-50%)" },
    { top: "100%", left: "20%", transform: "translate(-75%,-15%)" },
    { top: "0%", left: "45%", transform: "translate(-50%,-75%)" },
    { top: "30%", left: "100%", transform: "translate(-10%,-50%)" },
  ],
  [region8]: [
    { top: "23%", left: "0%", transform: "translate(-50%,-50%)" },
    { top: "100%", left: "0%", transform: "translate(-40%,-50%)" },
    { top: "100%", left: "60%", transform: "translate(-45%,-35%)" },
  ],
}

export const tooltipWidth = {
  [region1]: {
    width: "30vmin",
    height: "35vmin",
    maxWidth: "265px",
    maxHeight: "265px",
  },
  [region2]: {
    width: "38vmin",
    height: "20vmin",
    maxWidth: "300px",
    maxHeight: "160px",
  },
  [region3]: {
    width: "25vmin",
    height: "20vmin",
    maxWidth: "203px",
    maxHeight: "160px",
  },
  [region4]: {
    width: "16vmin",
    height: "25vmin",
    maxHeight: "220px",
    maxWidth: "140px",
  },
  [region5]: {
    width: "20vmin",
    height: "20vmin",
    // maxHeight: "310px",
    // maxWidth: "285px",
  },
  [region6]: {
    width: "40vmin",
    height: "35vmin",
    maxHeight: "245px",
    maxWidth: "285px",
  },
  [region7]: {
    width: "20vmin",
    height: "20vmin",
    maxWidth: "160px",
    maxHeight: "160px",
  },
  [region8]: {
    width: "35vmin",
    height: "32vmin",
    maxWidth: "265px",
    maxHeight: "265px",
  },
}

export default regionMapping
